export const FETCH_ORDER_ACCEPT_PENDING = "FETCH_ORDER_ACCEPT_PENDING";
export const FETCH_ORDER_ACCEPT_REJECTED = "FETCH_ORDER_ACCEPT_REJECTED";
export const FETCH_ORDER_ACCEPT_FULFILLED = "FETCH_ORDER_ACCEPT_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/orderAccept.js